import { Component } from "react";

import BookingItem from "./BookingItem";
import _ from "underscore";

export default class FinancingDetails extends Component {
  constructor(props) {
    super(props);
    const credit = props.item;

    this.state = { credit, investmentInfo: props.investmentInfo };
  }

  UNSAFE_componentWillMount() {
    let existingInvestmentInfo = _.find(
      this.state.investmentInfo,
      (investmentInfo) => {
        return investmentInfo.CreditId == this.state.credit.IntId;
      },
    );

    // Fetch account info if it's not present
    if (!existingInvestmentInfo)
      this.props.getInvestmentInfo(this.state.credit.IntId);
  }

  render() {
    if (!this.props.investmentInfo || this.props.investmentInfo.length === 0)
      return <div>No investments</div>;

    return (
      <div>
        <h4>Investments:</h4>{" "}
        {this.props.investmentInfo.map((item, index) => {
          return (
            <BookingItem
              key={`booking-${index}`}
              item={item}
              expanded={this.props.expanded}
            />
          );
        })}
      </div>
    );
  }
}
